<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout row wrap pa-3>
          <v-flex lg3 md3 sm12>
            <v-text-field :readonly="currentItem.Status == bill_status.da_xuat" label="Mã phiếu xuất"
              v-model="currentItem.BillCode" class="input-group--focused" outlined dense></v-text-field>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-autocomplete :readonly="currentItem.Status == bill_status.da_xuat" label="Khách hàng"
              v-model="currentItem.UID" :items="customers" item-text="Username" item-value="ID"
              @change="onCustomerChanged" outlined dense></v-autocomplete>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker readonly plabel="Ngày xuất" class="input-group--focused date-picker" v-model="exportDate"
              @onChangeDate="exportDate = $event"></mh-date-picker>
          </v-flex>
          <!-- <v-flex lg3 md3 sm12>
            <h-currency-input label="Tỷ giá" v-model="currentItem.ExchangeRate" :decimal="0" class="input-group--focused"></h-currency-input>
          </v-flex> -->

          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Tổng bill" v-model="currentItem.NumberOfCode" :decimal="0"
              class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Tổng kiện" v-model="currentItem.NumberOfPack" :decimal="0"
              class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Tổng cân" v-model="currentItem.Weight" :decimal="1"
              class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Tổng khối" v-model="currentItem.Volume" :decimal="2"
              class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Tổng tiền" v-model="currentItem.AmountVND" :decimal="0"
              class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Thành tiền" v-model="currentItem.LineAmount" :decimal="0"
              class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input label="Đã thanh toán" v-model="currentItem.PaidAmount" :decimal="0"
              class="input-group--focused"></h-currency-input>
          </v-flex>

        </v-layout>
      </v-card>
    </v-container>
    <v-container grid-list-xl fluid pt-6>
      <v-card>
        <v-layout row wrap pa-3>
          <v-flex lg12 md12 sm12>
            <v-layout row wrap justify-end pr-1>
              <v-btn class="mx-2" dark small color="red" @click="addDetail"
                :disabled="currentItem.Status == bill_status.da_xuat" v-if="roleEditable"><v-icon
                  dark>add</v-icon></v-btn>
            </v-layout>
          </v-flex>
          <v-flex lg12>
            <v-data-table :headers="detail_header" :items="details" disable-pagination hide-default-footer>
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.CustomerName }}</td>
                  <td>{{ item.PartnerName }}</td>
                  <td>{{ item.ProductNameCN }}</td>
                  <td>{{ item.SuffixBill }}</td>
                  <td class="text-right" v-if="roleEditable">
                    <v-edit-dialog :return-value.sync="item.Weight" large lazy
                      @save="saveBillProduct({ 'BillID': itemId, 'ProductID': item.ID, 'Weight': item.Weight })">
                      <div>{{ item.Weight | currency('', 1) }}</div>
                      <template v-slot:input>
                        <v-text-field v-model="item.Weight" type="number" step=".1" label="Cân nặng" single-line
                          autofocus></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-right" v-else>{{ item.Weight | currency("", 1) }}</td>
                  <td class="text-right" v-if="roleEditable">
                    <v-edit-dialog :return-value.sync="item.Volume" large lazy
                      @save="saveBillProduct({ 'BillID': itemId, 'ProductID': item.ID, 'Volume': item.Volume })">
                      <div>{{ item.Volume | currency('', 2) }}</div>
                      <template v-slot:input>
                        <v-text-field v-model="item.Volume" type="number" step=".01" label="Thể tích" single-line
                          autofocus></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-right" v-else>{{ item.Volume | currency("", 2) }}</td>
                  <td class="text-right" v-if="roleEditable">
                    <v-edit-dialog :return-value.sync="item.NumberOfPack" large lazy
                      @save="saveBillProduct({ 'BillID': itemId, 'ProductID': item.ID, 'NumberOfPack': item.NumberOfPack })">
                      <div>{{ item.NumberOfPack | currency }}</div>
                      <template v-slot:input>
                        <v-text-field v-model="item.NumberOfPack" type="number" step="1" label="Số kiện hàng"
                          single-line autofocus></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-right" v-else>{{ item.NumberOfPack | currency }}</td>
                  <td class="text-right">{{ item.Deposit | currency }}</td>
                  <td class="text-right">{{ item.ImportTaxAmount | currency }}</td>
                  <td class="text-right">{{ item.VatTaxAmount | currency }}</td>
                  <td class="text-right">{{ item.ServiceFeeAmount | currency }}</td>
                  <td class="text-right" v-if="roleEditable">
                    <v-edit-dialog :return-value.sync="item.FeeShipVND" large lazy
                      @save="saveBillProduct({ 'BillID': itemId, 'ProductID': item.ID, 'FeeShipVND': item.FeeShipVND })">
                      <div>{{ item.FeeShipVND | currency }}</div>
                      <template v-slot:input>
                        <v-text-field v-model="item.FeeShipVND" type="number" step="1" label="Phí ship" single-line
                          autofocus></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-right" v-else>{{ item.FeeShipVND | currency }}</td>
                  <td class="text-right">{{ item.Amount | currency }}</td>
                  <td class="text-right" v-if="roleEditable">
                    <v-edit-dialog :return-value.sync="item.DiscountAmount" large lazy
                      @save="saveBillProduct({ 'BillID': itemId, 'ProductID': item.ID, 'DiscountAmount': item.DiscountAmount })">
                      <div>{{ item.DiscountAmount | currency }}</div>
                      <template v-slot:input>
                        <v-text-field v-model="item.DiscountAmount" type="number" step="1" label="Chiết khấu"
                          single-line autofocus></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-right" v-else>{{ item.DiscountAmount | currency }}</td>
                  <td class="text-right">{{ item.LineAmount | currency }}</td>
                  <td v-if="roleEditable">
                    <v-edit-dialog :return-value.sync="item.Note" large lazy
                      @save="saveBillProduct({ 'BillID': itemId, 'ProductID': item.ID, 'Note': item.Note })">
                      <div>{{ item.Note }}</div>
                      <template v-slot:input>
                        <v-text-field v-model="item.Note" label="Ghi chú" single-line autofocus></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td v-else>{{ item.Note }}</td>
                  <td class="text-center">
                    <v-icon medium @click="deleteDetail(item.ID)" v-if="roleEditable">delete</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogItem" max-width="1300px">
      <v-card>
        <v-card-title>
          <span class="title">Danh sách hàng hóa</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
          <v-btn @click="onSelectDetail">Lưu lại</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <hpo-filter :headers="popup_header" :viewName="popupViewName" v-on:applyFilter="applyFilterDetail"
                  v-on:quickFilter="quickFilterDetail"></hpo-filter>
                <v-data-table fixed-header height="450px" :headers="popup_header" :items="popup_items" item-key="ID"
                  disable-pagination hide-default-footer show-select v-model="selectedDetail">
                  <template v-slot:item="{ item, isSelected, select }">
                    <tr :active="isSelected" @click="select(!isSelected)">
                      <td><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                      <td>{{ item.CustomerName }}</td>
                      <td>{{ item.PartnerName }}</td>
                      <td>{{ item.ProductNameCN }}</td>
                      <td>{{ item.SuffixBill }}</td>
                      <td class="text-right">{{ item.Deposit | currency }}</td>
                      <td class="text-right">{{ item.Weight | currency("", 1) }}</td>
                      <td class="text-right">{{ item.Volume | currency("", 2) }}</td>
                      <td class="text-right">{{ ((item.NumberOfPackImport | 0) - (item.NumberOfPackExport | 0)) |
                        currency
                        }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Filtering from "@/components/Filtering";
import configs from "@/configs";
import MHDatePicker from "@/components/daterange/MHDatePicker";
import moment from "moment";
import { print_export_receipt } from '@/commons/hpod';
export default {
  components: {
    "mh-date-picker": MHDatePicker,
    "hpo-filter": Filtering,
  },
  data() {
    return {
      exportDate: null,
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: { ...configs.PAGINATION },
      items_per_page: { ...configs.ITEMS_PER_PAGE },
      packageStatus: configs.PACKAGE_STATUS,
      product_status: configs.PRODUCT_STATUS,
      bill_status: configs.BILL_STATUS,
      bill_status_list: configs.BILL_STATUS_LIST,
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã bao",
          value: "BigPackageCode",
          sortable: true,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          sortable: true,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.PACKAGE_STATUS
        },
        {
          text: "S.Kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "KG",
          value: "Weight",
          align: "end",
          decimal: 1,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "M3",
          value: "Volume",
          align: "end",
          decimal: 1,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "P.Ship (¥)",
          value: "FeeShip",
          align: "end",
          decimal: 2,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        }
      ],
      detail_header: [
        {
          text: "Mã KH",
          value: "UserName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã đại lý",
          value: "PartnerName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên hàng",
          value: "ProductNameCN",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã vận đơn",
          value: "SuffixBill",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tổng kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Chi kho TQ",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thuế nhập khẩu",
          value: "ImportTaxAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Thuế VAT",
          value: "VatTaxAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí dịch vụ",
          value: "ServiceFeeAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí ship",
          value: "FeeShipVND",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tổng tiền",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chiết khấu",
          value: "DiscountAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Thành tiền",
          value: "LineAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Ghi chú",
          value: "Note",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "",
          value: "",
          align: "center",
          width: "80px",
        },
      ],
      filterConditions: [],
      quickFilterConditions: [],
      dialogItem: false,
      popup_header: [
        {
          text: "Mã KH",
          value: "UserName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã đại lý",
          value: "PartnerName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên hàng",
          value: "ProductNameCN",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã vận đơn",
          value: "SuffixBill",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Chi kho TQ",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tổng kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        }
      ],
      popupViewName: "popup_detail",
      selectedDetail: [],
    };
  },
  computed: {
    ...mapState({
      customers: state => state.customer.master.data,
      currentItem: state => state.bill.selected,
      details: state => state.product.billList.data,
      total_details: state => state.product.billList.total,
      loading: state => state.bill.loading,
      popup_items: state => state.product.all.data,
    }),
    itemId() {
      return Number(this.$route.params.Pid);
    },
    computedCreatedDateFormatted() {
      return moment(this.currentItem.CreatedDate).format(configs.DATE_FORMAT);
    },
    computedPaymentDateFormatted() {
      return this.currentItem.PaymentDate ? moment(this.currentItem.PaymentDate).format(configs.DATE_FORMAT) : '';
    },
    roleEditable() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.CustomerSupport;
    },
    roleCustomer() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Customer;
    },
  },
  watch: {
    currentItem() {
      this.exportDate = this.currentItem.ExportDate
        ? moment.utc(this.currentItem.ExportDate).format('YYYY-MM-DD')
        : null;
      if (this.currentItem.UID && this.customers.length > 0) {
        this.onCustomerChanged();
      }
    },
    customers() {
      if (this.currentItem.UID && this.customers.length > 0) {
        this.onCustomerChanged();
      }
    },
    roleEditable() {
      this.$root.$emit('REQUEST_ROOT_OPTION', { invisibleSaveButton: !this.roleEditable });
    },
    details() {
      this.selectedDetail = [];
    }
  },
  methods: {
    applyFilterDetail(filterConditions) {
      this.filterConditions = filterConditions;
      this.getAvailableProduct();
    },
    quickFilterDetail(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.getAvailableProduct();
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    onCustomerChanged() {
      let customer = _.find(this.customers, { ID: this.currentItem.UID });
      this.currentItem.CustomerName = customer ? customer.Username : '';
      this.currentItem.ReceiveName = customer ? customer.FullName : '';
      this.currentItem.ReceivePhone = customer ? customer.PhoneNumber : '';
      this.currentItem.ReceiveAddress = customer ? customer.Address : '';
    },
    getAvailableProduct() {
      var param = {
        filter: [...this.filterConditions],
        quickFilter: this.quickFilterConditions
      };
      param.filter.push({
        column: "Status",
        value: [this.product_status.nhap_kho_vn, this.product_status.xuat_thieu],
        condition: "in",
      });
      param.filter.push({
        column: "UID",
        value: this.currentItem.UID,
        condition: "equal",
      });
      param.filter.push({
        column: "UID",
        value: 0,
        condition: "does_not_equal",
      });
      param.action = "ton-kho-vn";
      this.$store.dispatch("product/getList", param);
    },
    addDetail() {
      this.dialogItem = true;
      this.getAvailableProduct();
    },
    deleteDetail(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },
    onSelectDetail() {
      if (this.selectedDetail.length > 0) {
        let submitList = [];
        let payload = {};
        if (!this.itemId) {
          payload = { ...this.currentItem, }
        }
        for (const item of this.selectedDetail) {
          submitList.push(item.ID);
        }
        payload.Products = submitList;
        this.$store.dispatch("bill/setDetail", {
          data: payload,
          id: this.currentItem.ID,
          ignore_compare: true
        }).then((ret) => {
          ret = ret.data ? ret.data : ret;
          if (_.isEmpty(ret)) {
            sendErrorNotice("Lỗi, không load được dữ liệu.");
          } else if (!this.currentItem.ID) {
            this.$router.push({
              name: "BillDetail",
              params: { Pid: ret.ID, title: `Chi tiết hóa đơn` },
            });
            this.getDetail();
          }
        });
        this.selectedService = [];
        this.dialogItem = false;
      }
    },
    saveData() {
      this.$store.dispatch("bill/setDetail", {
        data: { ...this.currentItem, ExportDate: this.exportDate ? moment.utc(this.exportDate).format(configs.SQL_DATE_FORMAT) : moment().format(configs.SQL_DATE_FORMAT), },
        id: this.currentItem.ID,
        ignore_compare: true
      });
    },
    saveProduct(item) {
      this.$store.dispatch("product/setDetail", {
        'data': item,
        'id': item.ID
      });
    },
    saveBillProduct(item) {
      this.$store.dispatch("billProduct/setDetail", {
        'data': {
          ...item
        },
        'id': 99999999
      });
    },
    deliverItem() {
      this.$store.dispatch("bill/setDetail", {
        data: { Status: this.bill_status.da_xuat },
        id: this.currentItem.ID,
        ignore_compare: true
      });
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
        is_master: 1,
        fields: ["ID", "Username", "FullName", "PhoneNumber", "Address"]
      });
    },
    getDetail() {
      this.getCustomerList();
      if (!this.itemId) {
        this.$store.commit("bill/setDetail", { ID: 0, UID: 0, Status: 1, ShipmentWeightPrice: 0, ShipmentVolumePrice: 0 });
      } else {
        this.$store.dispatch("bill/getDetail", this.itemId).then((ret) => {
          ret = ret.data ? ret.data : ret;
          if (_.isEmpty(ret)) {
            sendErrorNotice("Lỗi, không load được dữ liệu.");
          }
        });
        this.$store.dispatch("product/getBillList", this.itemId);
      }
    },
    printItem() {
      print_export_receipt(this.currentItem, this.details);
    }
  },
  mounted() {
    this.getDetail();
    this.$root.$emit('REQUEST_ROOT_OPTION', { invisibleSaveButton: !this.roleEditable });
    this.$root.$on("REQUEST_CREATE_DATA", this.printItem);
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("product/setDetail", {
        'data': { 'BillID': 0 },
        'id': id
      });
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA");
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
